(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('global-expense-type', {
            parent: 'entity',
            url: '/global-expense-type?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.globalExpenseType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/global-expense-type/global-expense-types.html',
                    controller: 'GlobalExpenseTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('globalExpenseType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('global-expense-type-detail', {
            parent: 'entity',
            url: '/global-expense-type/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.globalExpenseType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/global-expense-type/global-expense-type-detail.html',
                    controller: 'GlobalExpenseTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('globalExpenseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GlobalExpenseType', function($stateParams, GlobalExpenseType) {
                    return GlobalExpenseType.get({id : $stateParams.id});
                }]
            }
        })
        .state('global-expense-type.new', {
            parent: 'global-expense-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/global-expense-type/global-expense-type-dialog.html',
                    controller: 'GlobalExpenseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('global-expense-type', null, { reload: true });
                }, function() {
                    $state.go('global-expense-type');
                });
            }]
        })
        .state('global-expense-type.edit', {
            parent: 'global-expense-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/global-expense-type/global-expense-type-dialog.html',
                    controller: 'GlobalExpenseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GlobalExpenseType', function(GlobalExpenseType) {
                            return GlobalExpenseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('global-expense-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('global-expense-type.delete', {
            parent: 'global-expense-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/global-expense-type/global-expense-type-delete-dialog.html',
                    controller: 'GlobalExpenseTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GlobalExpenseType', function(GlobalExpenseType) {
                            return GlobalExpenseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('global-expense-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
